import * as y from 'yup'

export const EMAIL_DOMAIN_NAME = /@.+\..+/

// Regex used by yup.email() validation
// /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
export const EMAIL_PATTERN =
  /^[a-zA-ZÀ-Ÿ0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-ZÀ-Ÿ0-9](?:[a-zA-ZÀ-Ÿ0-9-]{0,61}[a-zA-ZÀ-Ÿ0-9])?(?:\.[a-zA-ZÀ-Ÿ0-9](?:[a-zA-ZÀ-Ÿ0-9-]{0,61}[a-zA-ZÀ-Ÿ0-9])?)*$/

export const emailSchema = y.object({
  email: y
    .string()
    .max(50, 'email.invalid')
    .matches(EMAIL_PATTERN, 'email.invalid')
    .matches(EMAIL_DOMAIN_NAME, 'email.invalid'),
})

export type EmailSchema = y.InferType<typeof emailSchema>
